import type { AllRouteEndpoints } from "../routeTypes";

export const alloysPartnersDatadogAppGroupId = "/alloys/partners/datadog/:app_group_id";

export const deleteAlloysPartnersDatadogAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysPartnersDatadogAppGroupId,
];

export const postAlloysPartnersDatadogAppGroupIdCacheKeys: AllRouteEndpoints[] = [alloysPartnersDatadogAppGroupId];
